import { createSelector } from 'reselect';

const getCountries = (state) => state.countryProfile.countries;
const getHomeContent = (state) => state.home.list;

const getTotalAssetments = createSelector(
  getCountries,
  (countries) => {
    let count = 0;
    if (!countries.length) return count;

    countries.forEach(country => {
      count += country['country-sectors'].length;
    });

    return count;
  }
);

const parseHomeContent = createSelector(
  getHomeContent,
  (contentList) => {
    const sections = {};
    contentList.forEach(l => sections[l.section] = l);
    return sections;
  }
);

export { getTotalAssetments, parseHomeContent };



// WEBPACK FOOTER //
// ./app/selectors/common.js